import SlideOverBody from '../../../component/body';
import SlideOverHeader from '../../../component/header';
import useSlideOver from '../../../useSlideOver';
import TimeSheetHistoryList from 'components/timeSheetHistory/TimeSheetHistoryList';
import UseContext from 'hooks/useContext';
import useTimeSheetHistory from 'hooks/useTimeSheetHistory';

const SlideOverTimeSheetHistory = () => {
  const { timeSheetHistoryId, setTimeSheetHistoryId } = UseContext();
  const { toggleSlideOver } = useSlideOver();
  const { events, isLoading, error } = useTimeSheetHistory(timeSheetHistoryId);

  const closeSlideOver = () => {
    toggleSlideOver('');
    setTimeSheetHistoryId(null);
  };

  return (
    <>
      <SlideOverHeader hide={closeSlideOver} hideShow={true}>
        Historique du relevé
      </SlideOverHeader>
      {/* The body's padding belongs to the scroll area, so content would scroll
          above a `sticky top-0` day header. This panel lays out its own padding
          instead, letting those headers span edge to edge. */}
      <SlideOverBody className="!p-0">
        {timeSheetHistoryId ? (
          <div className="flex flex-col">
            <p className="ft-sm text-gray-500 px-4 md:px-6 pt-4 md:pt-6 pb-4">
              Actions enregistrées sur ce relevé, de la plus récente à la plus
              ancienne.
            </p>

            <TimeSheetHistoryList
              events={events}
              isLoading={isLoading}
              error={error}
            />
          </div>
        ) : (
          <div className="p-4 md:p-6 text-gray-500">
            Aucun relevé sélectionné
          </div>
        )}
      </SlideOverBody>
    </>
  );
};

export default SlideOverTimeSheetHistory;
